var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7.65 2.975h18.7a2.84 2.84 0 0 1 2.833 2.833v3.117c0 1.133-.708 2.55-1.416 3.258l-6.092 5.383c-.85.709-1.417 2.125-1.417 3.259v6.091c0 .85-.566 1.984-1.275 2.409L17 30.6c-1.842 1.133-4.392-.142-4.392-2.409v-7.508c0-.992-.566-2.267-1.133-2.975L6.092 12.04c-.709-.708-1.275-1.983-1.275-2.833V5.95c0-1.7 1.275-2.975 2.833-2.975M15.484 2.975 8.5 14.166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.906c10e4080d5dfc1251fff7785aba9a.svg";
export { ForwardRef as ReactComponent };